const $ = window.jQuery;
const MenuOpen = {

    init () {
        $('.menu-left .c-icon-burger').click(function(){
            $('header').toggleClass('active')
            $('main').toggleClass('active')
            $('section').toggleClass('active')
            $('#menu-left').toggleClass('active')
            $('footer').toggleClass('active')
            $('.c-icon-burger').toggleClass('is-pressed')
          });

        $(".cart-mini-icn").click(function(){
            $(".widget_shopping_cart_content_ps").fadeToggle();
        });
        $(".cls-btn").click(function(){
            $(".widget_shopping_cart_content_ps").fadeOut();
        });
    },


};

export default MenuOpen;